"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledList = exports.StyledButton = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var StyledButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin: 0 4px;\n  padding: 8px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  color: ", ";\n  align-items: center;\n  border-radius: 2px;\n  cursor: pointer;\n  font-family: ", ";\n  position: relative;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.active {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.button {\n    background:  ", ";\n    color: ", ";\n    border-radius: 20px;\n    max-height: 40px;\n\n    &:hover {\n      background:  ", ";\n    }\n  }\n\n  .icon {\n    font-size: 24px;\n  }\n\n  .label {\n    font-size: 16px;\n    text-indent: 14px;\n  }\n\n  .dropdown-icon {\n    font-size: 18px;\n    position: absolute;\n    right: 8px;\n  }\n"], ["\n  display: flex;\n  margin: 0 4px;\n  padding: 8px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  color: ", ";\n  align-items: center;\n  border-radius: 2px;\n  cursor: pointer;\n  font-family: ", ";\n  position: relative;\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.active {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.button {\n    background:  ", ";\n    color: ", ";\n    border-radius: 20px;\n    max-height: 40px;\n\n    &:hover {\n      background:  ", ";\n    }\n  }\n\n  .icon {\n    font-size: 24px;\n  }\n\n  .label {\n    font-size: 16px;\n    text-indent: 14px;\n  }\n\n  .dropdown-icon {\n    font-size: 18px;\n    position: absolute;\n    right: 8px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.grey.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary.dark;
});
exports.StyledButton = StyledButton;
var StyledList = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  list-style: none;\n  margin-bottom: 16px;\n\n  &.open {\n    height: auto;\n  }\n\n  .dropdown-item {\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: normal;\n    color: ", ";\n    padding-left: 32px;\n    height: 40px;\n    cursor: pointer;\n    background: transparent;\n\n    &:hover,\n    &.active {\n      color: ", ";\n    }\n  }\n  \n"], ["\n  height: 0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  list-style: none;\n  margin-bottom: 16px;\n\n  &.open {\n    height: auto;\n  }\n\n  .dropdown-item {\n    font-family: ", ";\n    font-size: 16px;\n    font-weight: normal;\n    color: ", ";\n    padding-left: 32px;\n    height: 40px;\n    cursor: pointer;\n    background: transparent;\n\n    &:hover,\n    &.active {\n      color: ", ";\n    }\n  }\n  \n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontFamily;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.light;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.typography.medium;
});
exports.StyledList = StyledList;
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map